import React from 'react'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'

import { useDropzoneAreaStyles } from './dropzone-area.styles'
import { FileObject } from './dropzone-area.types'
import { TranslationDictionary } from '@plandi/common'
import Image from 'next/image'

type DropzoneAreaPreviewListProps = {
  previewText?: string
  fileObjects?: FileObject[]
  onDelete: (
    file: FileObject,
    index: number
  ) => (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  getFileName?: (file: FileObject, index: number) => string
  getFileUrl?: (file: FileObject, index: number) => string
  showFileNames?: boolean
  previewImg: boolean
  previewVideo?: boolean
  previewFile3D?: boolean
  translate?: TranslationDictionary['data']
}

export const DropzoneAreaPreviewList: React.FC<DropzoneAreaPreviewListProps> = (
  props
) => {
  const classes = useDropzoneAreaStyles()

  return (
    <>
      <div
        className={classes.previewList}
        style={{ marginTop: props.previewFile3D ? 15 : 0 }}
      >
        {props.fileObjects?.map((file, index) => {
          const fileUrl =
            props.getFileUrl?.(file, index) ?? file.data?.toString()

          const fileName =
            props.getFileName?.(file, index) ??
            file?.file?.name ??
            props.translate?.['job-site']?.['not-name'] ??
            'Без имени'

          return (
            <div key={index} className={classes.item}>
              {props.previewImg &&
                fileUrl &&
                (props.previewVideo ? (
                  <video
                    autoPlay
                    loop
                    muted
                    width={160}
                    height={90}
                    style={{ marginRight: 12 }}
                  >
                    <source src={fileUrl} />
                  </video>
                ) : (
                  <Image
                    width={56}
                    height={56}
                    className={classes.image}
                    role="presentation"
                    src={fileUrl}
                    alt={fileName}
                  />
                ))}

              {props.showFileNames && (
                <Typography variant="subtitle2" component="p" noWrap>
                  {fileName}
                </Typography>
              )}

              <IconButton
                onClick={props.onDelete(file, index)}
                className={classes.removeButton}
              >
                <CloseIcon />
              </IconButton>
            </div>
          )
        })}
      </div>
    </>
  )
}
